export default function IconVolumeUp() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 11C4 10.4477 4.44772 10 5 10H8V22H5C4.44772 22 4 21.5523 4 21V11Z" fill="currentColor" />
      <path d="M8 10L13.3492 5.41496C13.9979 4.85896 15 5.31987 15 6.17422V25.8258C15 26.6801 13.9979 27.141 13.3492 26.585L8 22V10Z"
        fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd"
        d="M17 26.8732C17 27.4579 17.501 27.9216 18.077 27.8211C23.7145 26.8374 28 21.9192 28 16.0002C28 10.0811 23.7145 5.163 18.077 4.17929C17.501 4.07878 17 4.54245 17 5.12716V7.17903C17 7.68347 17.3782 8.10223 17.8688 8.21964C21.3856 9.06125 24 12.2254 24 16.0002C24 19.775 21.3856 22.9391 17.8688 23.7807C17.3782 23.8981 17 24.3169 17 24.8213V26.8732Z"
        fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd"
        d="M17 20.0383C17 20.5906 17.4564 21.0517 17.9872 20.899C19.8412 20.3655 21.2192 18.3634 21.2192 15.975C21.2192 13.5867 19.8412 11.5845 17.9872 11.0511C17.4564 10.8984 17 11.3594 17 11.9117V20.0383Z"
        fill="currentColor" />
    </svg>
  );
}
